"use client";

import React from "react";
import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Pagination, Autoplay } from "swiper/modules";

const SLIDE_W = 249;
const SLIDE_H = 554;
const GAP = 12;
const DESIRED = 5;

const images = [
      { src: "/images/screens/app-screen-1.png", alt: "screen-1" },
      { src: "/images/screens/app-screen-2.png", alt: "screen-2" },
      { src: "/images/screens/app-screen-3.png", alt: "screen-3" },
      { src: "/images/screens/app-screen-4.png", alt: "screen-4" },
      { src: "/images/screens/app-screen-5.png", alt: "screen-5" },
      { src: "/images/screens/app-screen-6.png", alt: "screen-6" },
];

export default function AppScreens() {
      const shellRef = React.useRef(null);
      const [perView, setPerView] = React.useState(1);

      // Compute how many slides fit: n * SLIDE_W + (n-1) * GAP <= containerWidth
      React.useEffect(() => {
            const el = shellRef.current;
            if (!el) return;

            const compute = (w) => {
                  const maxSlides = Math.floor((w + GAP) / (SLIDE_W + GAP));
                  const fit = Math.max(
                        1,
                        Math.min(DESIRED, Math.min(images.length, maxSlides))
                  );
                  setPerView(fit);
            };

            compute(el.clientWidth);

            const ro = new ResizeObserver((entries) => {
                  for (const entry of entries) compute(entry.contentRect.width);
            });
            ro.observe(el);
            return () => ro.disconnect();
      }, []);

      const initial = Math.min(images.length - 1, 2);

      return (
            <section className="w-full olmo-app-screen" style={{ background: "#455565", position: "relative", paddingTop: 90, paddingBottom: 90 }}>
                  <h2 className="title text-white" style={{ textAlign: 'center' }}>Platform Overview</h2>
                  <div
                        aria-hidden
                        style={{ position: "absolute", maxWidth: 448, top: "5rem", left: "10rem", zIndex: 1, pointerEvents: 'none' }}
                  >
                        <Image
                              src="/images/app-screens-bg-img-1.png"
                              alt="screen"
                              width={448}
                              height={448}
                              style={{ objectFit: "contain" }}
                              priority={false}
                        />
                  </div>
                  <div
                        aria-hidden
                        style={{ position: "absolute", maxWidth: 448, right: "10rem", bottom: "6rem", zIndex: 2, pointerEvents: 'none' }}
                  >
                        <Image
                              src="/images/app-screens-bg-img-1.png"
                              alt=""
                              width={448}
                              height={448}
                              style={{ objectFit: "contain" }}
                              priority={false}
                        />
                  </div>


                  {/* parent max-width = 1200px */}
                  <div style={{ margin: "0 auto", padding: "0 12px", }}>

                        {/* Measure THIS element for exact available width (no inner padding) */}
                        <div ref={shellRef} style={{ marginTop: 40, overflow: "hidden", position: 'relative', zIndex: 3 }} className="container">
                              <Swiper
                                    modules={[EffectCoverflow, Pagination, Autoplay]}
                                    effect="coverflow"
                                    grabCursor
                                    centeredSlides
                                    loop={true}
                                    initialSlide={initial}
                                    speed={400}
                                    slidesPerView={perView}
                                    spaceBetween={GAP}
                                    allowTouchMove={images.length > 1}
                                    autoplay={{ delay: 3000, disableOnInteraction: false, pauseOnMouseEnter: true }}
                                    watchOverflow={false}
                                    pagination={{ clickable: true }}
                                    coverflowEffect={{
                                          rotate: 0,
                                          stretch: GAP,
                                          depth: 180,
                                          modifier: 1,
                                          slideShadows: false,
                                    }}
                                    className="!pb-10"
                              >
                                    {images.map((img, i) => (
                                          <SwiperSlide key={i} style={{ width: SLIDE_W, height: 690 }}>
                                                <div
                                                      className="rounded-3xl overflow-hidden"
                                                      style={{ width: SLIDE_W, height: SLIDE_H, margin: "0 auto" }}
                                                >
                                                      <Image
                                                            src={img.src}
                                                            alt={img.alt ?? `App screen ${i + 1}`}
                                                            width={SLIDE_W}
                                                            height={SLIDE_H}
                                                            style={{ objectFit: "contain", borderRadius: "1.5rem" }}
                                                      />
                                                </div>
                                          </SwiperSlide>
                                    ))}
                              </Swiper>
                        </div>
                  </div>
            </section>
      );
}
